import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'

import Backend from 'i18next-xhr-backend'
import translationEN from '../locales/en/translation.json'

// the translations
const resources = {
    en: {
        translation: translationEN,
    },
}

i18n.use(Backend)
    .use(initReactI18next)
    .init({
        debug: true,
        resources,
        lng: 'en',
        fallbackLng: 'en',
        whitelist: ['en'],

        interpolation: {
            escapeValue: false,
        },
        backend: {
            loadPath: `${CDN_BUCKET}/locales/{{lng}}/{{ns}}.json`,
        },
    })

export default i18n
